import React, { useEffect, useState } from 'react'
import Banner from './Banner';
import companyLogoIcon from '../../assets/plus_icon/company_logo.png';
import { ReactComponent as RightIcon } from '../../assets/righticon.svg'
import PhoneInput from 'react-phone-input-2';
import { ToastContainer } from 'react-toastify';
import { ReactComponent as LogoIcon } from '../../assets/logo.svg';
import ramaLogo from '../../assets/plus_icon/rama_logo.png'

const CustomerInfo = ({
    setChannelPartner,
    setIsWithCP,
    mobile,
    setMobile,
    name,
    setName,
    setIsCPVisit,
    handleGetReVisitCustomerDetails,
    setShowSiteVisitOTPModal,
    coverImage,
    projectName,
    brandLogo,
    activeVisitsCount,
    onOpenActiveVisitsModal,
    setSourcingManager,
    setSourcingManagerSource }) => {
    const [error, setError] = useState(false);
    const [mobileError, setMobileError] = useState(false)

    const handleSubmit = (isCpVal) => {
        if (!mobile) {
            setError(true);
            return
        } else {
            setError(false)
        }
        if (mobile.length < 12) {
            setMobileError(true);
            return;
        } else {
            setMobileError(false)
        }
        // setChannelPartner('3')
        handleGetReVisitCustomerDetails(mobile, isCpVal)
    }

    return (
        <div className=' mx-auto overflow-auto relative'>
            <div className='flex items-center justify-center !my-5 sm:!mb-10 sm:mt-8'>
                {/* <span className='w-[145px] border-t-2 border-[#696969]'></span> */}
                <figure className='m-0 h-[80px] sm:h-[90px] w-[228px]'>
                    <img src={brandLogo || ramaLogo} alt="" className='h-100 w-100 object-contain' />
                </figure>
                <div className='border-r-2 border-[#CFD5DE] h-[80px] sm:h-[100px] !ml-7 !mr-12'></div>
                <div className=''>
                    {/* <span className='text-xl sm:text-[34px] font-bold italic'>propacity</span> */}
                    <LogoIcon className='sm:w-[200px] sm:h-[90px] w-[130px] h-[62px] ' />
                    {/* <span className='text-xs sm:text-base !mt-3'>Powered By Propacity</span> */}
                </div>
                {/* <span className='w-[145px] border-t-2 border-[#696969]'></span> */}
            </div>

            <div className='!w-full customer-info'>
                <Banner coverImage={coverImage} projectName={projectName} />
            </div>
            <div className=' bg-white rounded-xl !mt-6 !p-6 sm:!p-10'>
                <div className='flex items-center justify-center'>
                    <p className='flex items-center flex-col mb-0  sm:!mx-10'>
                        <span className='text-xl sm:text-2xl font-semibold '>Welcome to {projectName || 'Krystal One'}</span>
                        <span className='text-sm sm:text-lg !mt-4 text-black700'>Please specify your check-in type</span>
                    </p>
                </div>
                <div className='!mt-6 space-y-4'>

                    {/* <div className={`flex flex-col font-medium relative w-full`}>
                        <label className='sm:!text-lg text-base !mb-3'>Customer Name<sup className='text-red'>*</sup></label>
                        <input
                            className={` border rounded-xl focus:outline-none focus:!border-primary  text-input sm:!text-lg text-sm placeholder:sm:!text-lg placeholder:!text-sm !py-2 !px-2 sm:!py-3 sm:!px-4`}
                            type={"text"}
                            placeholder={'Enter Name'}
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                        />
                        {error && !name && (
                            <div className="text-red sm:!text-sm text-xs !mt-4">Please Enter Customer Name</div>

                        )}
                    </div> */}

                    <div className={` font-medium position-relative flex flex-col`}>
                        <label className='sm:!text-lg text-base !mb-3'>Customer Mobile No.<sup className='text-red'>*</sup></label>
                        <PhoneInput
                            inputClass={'border !w-full focus:outline-none focus:border-primary rounded-xl text-input !h-[38px] sm:!h-[54px] text-sm sm:!text-base sm:placeholder:!text-2xl placeholder:!text-lg  !py-2 sm:!py-3'}
                            // containerClass={classname}
                            country={'in'}
                            value={mobile}
                            countryCodeEditable={false}
                            enableSearch={true}
                            disableSearchIcon={true}
                            onChange={phone => {
                                setMobile(phone)
                            }}
                        />
                        {error && !mobile && (
                            <div className="text-red sm:!text-sm text-xs !mt-4">Please Enter Customer Mobile</div>

                        )}
                        {
                            mobileError && mobile && <div className="text-red sm:!text-sm text-xs !mt-4">Please Enter Valid Mobile No.</div>
                        }
                    </div>
                    <div className='w-full flex flex-col sm:flex-row sm:space-x-6 space-y-4 sm:space-y-0'>
                        <div className=' rounded-xl border sm:w-1/2 sm:!py-3 !py-2 !h-[38px] sm:!h-[54px] flex justify-between cursor-pointer items-center sm:!px-6 !px-3' onClick={() => {
                            setIsWithCP(true)
                            // setChannelPartner('3')
                            handleSubmit(true)
                        }}>
                            <span className='text-sm sm:text-base text-blue-900 font-semibold leading-9'>Customer with CP</span>
                            <span>
                                <RightIcon className='stroke-blue-900 ' />
                            </span>
                        </div>
                        <div className='rounded-xl border sm:w-1/2 sm:!py-3 !py-2 !h-[38px] sm:!h-[54px] flex justify-between items-center sm:!px-6 !px-3' onClick={() => {
                            setIsWithCP(false)
                            // setChannelPartner('3')
                            handleSubmit(false)
                        }}>
                            <span className=' text-sm sm:text-base h text-blue-900 font-semibold cursor-pointer leading-9'>Customer Self Check-in</span>
                            <span >
                                <RightIcon className='stroke-blue-900 ' />
                            </span>
                        </div>
                    </div>

                    <div className='w-100 flex items-center justify-center '>
                        <span className='w-1/2 !border !border-dashed'></span>
                        <span className='!mx-1'>Or</span>
                        <span className='w-1/2 !border !border-dashed'></span>
                    </div>
                    <div className=' rounded-xl border w-full  sm:!py-3 !py-2 !h-[38px] sm:!h-[54px] flex justify-between cursor-pointer items-center sm:!px-6 !px-3' onClick={() => {
                        setIsCPVisit(true);
                        setIsWithCP(false);
                        if (setSourcingManager) setSourcingManager(null);
                        if (setSourcingManagerSource) setSourcingManagerSource(null);
                        setChannelPartner('4');
                    }}>
                        <span className='text-sm sm:text-base text-blue-900 font-semibold leading-9'>CP Visit</span>
                        <span>
                            <RightIcon className='stroke-blue-900 ' />
                        </span>
                    </div>
                    {/* SV Without Number */}
                    {/* <div className=' rounded-xl border w-full  sm:!py-3 !py-2 !h-[38px] sm:!h-[54px] flex justify-between cursor-pointer items-center sm:!px-6 !px-3' onClick={() => {
                        setShowSiteVisitOTPModal(true)
                    }}>
                        <span className='text-sm sm:text-base text-blue-900 font-semibold leading-9'>SV Without Number</span>
                        <span>
                            <RightIcon className='stroke-blue-900 ' />
                        </span>
                    </div> */}

                    {/* <div className='flex items-center justify-center w-full'>
                        <span className='border border-dashed w-1/2'></span>
                        <span className='mx-1.5 sm:mx-2.5'>or</span>
                        <span className='border border-dashed w-1/2'></span>
                    </div>
                    <div className='rounded-xl border sm:!py-5 !py-2 flex justify-between cursor-pointer items-center sm:!px-6 !px-3' onClick={() => setChannelPartner('4')}>
                        <span className='text-xl sm:text-2xl text-blue-900 font-semibold  leading-9'>CP Visit</span>
                        <span >
                            <RightIcon className='stroke-blue-900 ' />
                        </span>
                    </div> */}
                </div>

            </div>
        </div >
    )
}

export default CustomerInfo